import {
  maxLength,
  maxLengthNumericPhone,
  minLengthNumeric,
  nameField,
  phone,
} from 'utils/validation';

const firstNameValidator = {
  validate: { maxLength: maxLength(35), pattern: nameField('first name') },
};
const lastNameValidator = {
  validate: { maxLength: maxLength(35), pattern: nameField('last name') },
};
const phoneNumberValidator = {
  required: 'Please enter your contact number',
  validate: {
    pattern: phone,
    minLengthNumeric: minLengthNumeric(9),
    maxLengthNumericPhone: maxLengthNumericPhone(14),
  },
};

export { firstNameValidator, lastNameValidator, phoneNumberValidator };
